import React from "react";

export default class SmiWidget extends React.Component {
    componentDidMount() {
        (window.smiq = window.smiq || []).push({});
    }

    render() {
        return <div className="smi24__informer smi24__auto" data-smi-blockid="14885"></div>;
    }
}
